import React from "react";
import { motion } from "framer-motion";
import { useLanguage } from "@/context/LanguageContext";
import { commonLabels } from "@/i18n";

const AuctionTypesHeader = () => {
  const { language } = useLanguage();
  const labels = commonLabels(language);
  const headerData = labels.menuPages?.buyCar?.auctionTypesHeader || {};

  return (
    <motion.div
      initial={{ opacity: 0, y: 50 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8 }}
      viewport={{ once: true }}
      className="text-center mb-8 md:mb-10"
    >
      <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-gray-900 mb-3 md:mb-4">
        {headerData.title || "Olika Auktionstyper"}
      </h2>
      <p className="text-base md:text-lg text-gray-600 max-w-2xl mx-auto px-4">
        {headerData.description ||
          "Välj den auktionstyp som passar dig bäst. Alla auktioner har samma transparenta testprocess."}
      </p>
    </motion.div>
  );
};

export default AuctionTypesHeader;
